import React, { useRef, useCallback } from "react";
import { Form, Input, DatePicker, Button, Row, Col, Select } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import AircraftSelector from "../../../../components/common/AircraftSelector";

const { RangePicker } = DatePicker;
const { Option } = Select;

/**
 * 正式计划过滤器组件
 *
 * @param {boolean} autoApply - 自动应用模式：表单值变化自动触发 onSearch（防抖 500ms），隐藏搜索/重置按钮
 */
const ScheduleOfficialFilter = ({ onSearch, onReset, autoApply = false }) => {
    const [form] = Form.useForm();
    const debounceRef = useRef(null);

    const handleSearch = useCallback(() => {
        form.validateFields().then((values) => {
            onSearch(values);
        });
    }, [form, onSearch]);

    // 重置表单
    const handleReset = useCallback(() => {
        form.resetFields();
        onReset();
    }, [form, onReset]);

    // autoApply: 表单值变化自动触发搜索（防抖）
    const handleValuesChange = useCallback(() => {
        if (!autoApply) return;
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSearch();
        }, 500);
    }, [autoApply, handleSearch]);

    return (
        <Form form={form} layout="horizontal" onFinish={(values) => onSearch(values)} className="filter-form" labelAlign="right" onValuesChange={handleValuesChange}>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item label="计划名称" name="name">
                        <Input placeholder="请输入计划名称" allowClear />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label="时间范围" name="dateRange">
                        <RangePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label="飞机注册号" name="aircraft_id">
                        <AircraftSelector placeholder="请选择飞机注册号" allowClear valueType="id" displayMode="simple" mode="multiple" maxTagCount="responsive" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label="状态" name="status">
                        <Select placeholder="请选择状态" allowClear mode="multiple">
                            <Option value="SUBMITTED">已提交</Option>
                            <Option value="CONFIRMATION_PENDING">待确认</Option>
                            <Option value="AIRLINE_CONFIRMED">航司确认</Option>
                            <Option value="PUBLISHED">已发布</Option>
                            <Option value="DEPRECATED">已废弃</Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            {!autoApply && (
                <Row gutter={24}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ marginRight: 8 }}>
                                搜索
                            </Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset} style={{ marginRight: 8 }}>
                                重置
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            )}
        </Form>
    );
};

export default ScheduleOfficialFilter;
